export function loginErrorMessage(error: unknown, fallback: string): string {
  if (typeof error === 'object' && error !== null && 'response' in error) {
    const response = (error as { response?: { data?: { message?: unknown } } })
      .response;
    const msg = response?.data?.message;
    if (typeof msg === 'string' && msg.length > 0) return msg;
  }
  if (error instanceof Error && error.message) return error.message;
  return fallback;
}
